<template>
  <div class="page-card">
    <h2 class="page-title">商家开通审核</h2>

    <div class="toolbar">
      <div class="toolbar-left">
        <el-input
          v-model="query.keyword"
          placeholder="手机号/昵称/艺名"
          clearable
          style="width: 260px"
          @keyup.enter.native="handleSearch"
        />
        <el-select v-model="query.userStatus" clearable placeholder="账号状态" style="width: 140px">
          <el-option label="正常" :value="1" />
          <el-option label="封禁" :value="0" />
        </el-select>
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </div>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="artistName" label="艺名" min-width="150" />
      <el-table-column prop="nickname" label="昵称" min-width="130" />
      <el-table-column label="手机号" width="150">
        <template slot-scope="{ row }">{{ maskMobile(row.mobile) }}</template>
      </el-table-column>
      <el-table-column prop="city" label="城市" width="150" />
      <el-table-column label="艺人状态" width="120">
        <template slot-scope="{ row }">
          <el-tag :type="row.userStatus === 1 ? 'success' : 'danger'">
            {{ row.userStatus === 1 ? '正常' : '封禁' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="资料状态" width="120">
        <template slot-scope="{ row }">{{ profileStatusText(row.profileStatus) }}</template>
      </el-table-column>
      <el-table-column label="商家状态" min-width="180">
        <template slot-scope="{ row }">
          <el-tag v-if="row.merchantEnabled" type="success">已开通</el-tag>
          <el-tag v-else type="info">未开通</el-tag>
          <span v-if="row.merchantName" class="merchant-name">{{ row.merchantName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="资质状态" width="120">
        <template slot-scope="{ row }">{{ merchantAuthText(row.merchantAuthStatus) }}</template>
      </el-table-column>
      <el-table-column prop="createdAt" label="注册时间" width="180" />
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="{ row }">
          <el-button
            v-if="!row.merchantEnabled"
            type="primary"
            size="mini"
            :disabled="row.userStatus !== 1"
            :loading="openingId === resolveUserId(row)"
            @click="handleEnable(row)"
          >
            开通商家
          </el-button>
          <el-button v-else size="mini" disabled>已开通</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrap">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="query.page"
        :page-size.sync="query.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        @current-change="fetchData"
        @size-change="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui'
import { enableArtistMerchant, getArtistUsers } from '../../../api/platformManage'
import { maskMobile } from '../../../utils/format'

export default {
  name: 'ArtistMerchantEnablePage',
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      openingId: '',
      query: {
        keyword: '',
        userStatus: undefined,
        page: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    maskMobile,
    resolveUserId(row) {
      return row && row.userId != null ? String(row.userId) : ''
    },
    async fetchData() {
      this.loading = true
      try {
        const data = await getArtistUsers(this.query)
        this.list = data.records || []
        this.total = Number(data.total || 0)
        this.query.page = Number(data.page || this.query.page)
        this.query.pageSize = Number(data.pageSize || this.query.pageSize)
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.query.page = 1
      this.fetchData()
    },
    handleSizeChange() {
      this.query.page = 1
      this.fetchData()
    },
    async handleEnable(row) {
      const userId = this.resolveUserId(row)
      if (!userId) return
      try {
        await MessageBox.confirm(
          `确认给 ${row.artistName || row.nickname || maskMobile(row.mobile)} 开通商家角色吗？`,
          '开通确认',
          {
            type: 'warning',
            confirmButtonText: '确认开通',
            cancelButtonText: '取消'
          }
        )
      } catch (e) {
        return
      }
      this.openingId = userId
      try {
        await enableArtistMerchant(userId)
        this.$message.success('商家角色已开通')
        await this.fetchData()
      } finally {
        this.openingId = ''
      }
    },
    profileStatusText(status) {
      if (status === 2) return '已通过'
      if (status === 1) return '待审核'
      if (status === 3) return '已驳回'
      if (status === 4) return '待补充'
      if (status === 5) return '复审中'
      return '待完善'
    },
    merchantAuthText(status) {
      if (status === 2) return '已认证'
      if (status === 1) return '审核中'
      if (status === 3) return '已驳回'
      return '待认证'
    }
  }
}
</script>

<style scoped>
.merchant-name {
  margin-left: 8px;
  color: #606266;
}
</style>
